<template>
    <div class="form">
        <div class="form-container outer">
        <div class="form-form">
            <div class="form-form-wrap">
                <div class="form-container">
                    <div class="form-content">

                        <h1 class="">Sign In</h1>
                        <p class="">Log in to your account to continue.</p>
                        
                        <form class="text-left" @submit="login">
                            <div class="form">

                                <div id="email-field" class="field-wrapper input">
                                    <label for="email">Email</label>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                    <input id="email" name="email" type="email" class="form-control" placeholder="user@email.com" v-model="email" required>
                                </div>

                                <div id="password-field" class="field-wrapper input mb-2">
                                    <div class="d-flex justify-content-between">
                                        <label for="password">PASSWORD</label>
                                        <a href="#" class="forgot-pass-link">Forgot Password?</a>
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                                    <input id="password" name="password" type="password" class="form-control" placeholder="Password" v-model="password" required>
                                    <svg @click="chnangeEye" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id="toggle-password" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                </div>
                                <div v-if="error" id="error" class="center-error">
                                    <p class="color-red">{{error}}</p>
                                </div>
                                <div class="d-sm-flex justify-content-between">
                                    <div class="field-wrapper">
                                       <button type="submit" class="btn btn-primary" value="" :disabled="disabled">Log In</button>
                                    </div>
                                </div>

                            </div>
                        </form>

                    </div>                    
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';

export default {
    data() {
        return {
            email: '',
            password: '',
            disabled: false,
            error: ''
        }
    },
    methods: {
        chnangeEye(){
            const doc = document.getElementById('password');
            if(doc.type == 'password') doc.type = 'text';
            else doc.type = 'password';
        },
        async login (e) {
            e.preventDefault();
            this.disabled = true;
            this.error = '';

            const url = `${process.env.VUE_APP_SERVER_URL}/master/login`;
    
            const data = {
                email: this.email,
                password: this.password
            }

            try {
                const res = await axios({
                    method: 'post',
                    url,
                    data: qs.stringify(data),
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': '*',
                    }
                });
                const user = res.data;
                const token = user.Token;
                this.$store.dispatch('SET_USER', user);
                this.$store.dispatch('SET_TOKEN', token);
                this.$router.push({name: 'dashboard'});
            } catch (error) {
                this.error = 'Login failed';
            }finally{
                this.disabled = false;
            }
        }
    }
}
</script>
<style scoped>
.color-red {
    color: red;
}
.center-error {
    display: flex;
    justify-content: center;
}
</style>
